import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';

import { SharedModule } from '../../_shared/shared.module';
import { AbilityService } from '../../_shared/services/ability.service';
import { DataService } from '../../_shared/services/data.service';
import { SessionService } from '../../_shared/services/session.service';
import { UtilService } from '../../_shared/services/util.service';

import { RoomType } from '../shared/room-type.model';
import { RoomTypeService } from '../shared/room-type.service';

@Component({
  selector: 'app-room-type-list',
  templateUrl: './room-type-list.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class RoomTypeListComponent implements OnInit, OnDestroy {
  constructor(
    private roomTypeService: RoomTypeService,
    private abilityService: AbilityService,
    private dataService: DataService,
    private sessionService: SessionService,
    public utilService: UtilService
  ) {}

  @Input() roomTypes: RoomType[];
  @Input() meta;
  @Input() loadingRoomTypes: boolean;
  @Input() defaultLanguage;

  @Output() private selectedRoomType = new EventEmitter<{
    roomType: RoomType;
    mode: string;
  }>();

  permissions = {
    canShow: this.abilityService.can('show_roomtype_accountadmin'),
    canUpdate: this.abilityService.can('update_roomtype_accountadmin'),
    canDestroy: this.abilityService.can('destroy_roomtype_accountadmin'),
  };

  filterCriteria = this.roomTypeService.getFilterCriteria();

  masterCheckboxSelected = false;
  showListActions = false;
  totalItemsSelected = 0;

  private $subs: Subscription;

  ngOnInit() {
    this.$subs = this.utilService.getCheckboxsSubjectValue().subscribe((data) => {
      this.showListActions = data.showListActions;
      this.totalItemsSelected = data.totalItemsSelected;
      this.masterCheckboxSelected = data.masterCheckboxSelected;
    });
  }

  ngOnDestroy() {
    if (this.$subs) {
      this.$subs.unsubscribe();
    }
  }

  reloadRoomTypes() {
    this.filterCriteria = this.roomTypeService.getFilterCriteria();

    this.getRoomTypes();
  }

  // Referenced from app-search-text-input
  onSearched({ field, value }) {
    this.filterRoomTypes(field, value);
  }

  filterRoomTypes(field, value) {
    this.filterCriteria = this.utilService.setFilterCriteria(this.filterCriteria, field, value);

    this.getRoomTypes();
  }

  // Referenced from app-sort-by
  onSorted({ sortBy, sortDir }) {
    this.filterCriteria.page = 1;
    this.filterCriteria.sortDir = sortDir;
    this.filterCriteria.sortedBy = sortBy;

    this.getRoomTypes();
  }

  // Referenced from app-table-footer
  onSelectedPage({ page, offset }) {
    this.filterCriteria.page = page;
    this.filterCriteria.offset = offset;

    this.getRoomTypes();
  }

  selectRoomType(roomType: RoomType, mode = '') {
    if (!this.permissions.canShow) return;

    this.selectedRoomType.emit({ roomType, mode });
  }

  // Referenced from app-list-actions
  onUpdatedItems(option) {
    let successCallback = () => {
      this.getRoomTypes();
    };

    this.dataService.changeItemsStatus('room_types', this.roomTypes, option, successCallback);
  }

  // Referenced from app-list-actions
  onDeletedItems() {
    let successCallback = () => {
      this.getRoomTypes();
    };

    this.dataService.deleteItems('room_types', this.roomTypes, successCallback);
  }

  changeRoomTypeStatus(roomType: RoomType) {
    let successCallback = () => {
      this.utilService.changeItemRowStyle(roomType.id);
    };

    this.dataService.changeItemStatus('room_types', roomType, successCallback, {});
  }

  deleteRoomType(roomType: RoomType) {
    let successCallback = () => {
      this.getRoomTypes();
    };

    const params = {
      title: 'DELETE_ROOM_TYPE',
      // message: 'SURE_TO_DELETE_ROOM_TYPE',
      reason: 'DELETE_ITEM_REASON',
      requireConfirmation: true,
      successMsg: 'ROOM_TYPE_DELETED',
    };

    this.dataService.deleteItem('roomTypes', roomType, successCallback, params);
  }

  private getRoomTypes() {
    this.filterCriteria.lang = this.sessionService.getUserLanguage().code;

    this.loadingRoomTypes = true;
    this.roomTypeService.getRoomTypes(this.filterCriteria).subscribe((response) => {
      this.roomTypes = response.data;
      this.meta = response.meta;

      this.loadingRoomTypes = false;
    });
  }
}
